import React from "react";
import { FaBusinessTime } from "react-icons/fa";
import { apiFetch } from "./utils/api";
import "./Shift.css";

const NoShift = () => {
    const handleLogout = async () => {
        try {
            await apiFetch("/api/login/logout", { method: "POST", credentials: "include" });
        } catch (e) { /* ignore */ }
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/login";
    };

    return (
        <div className="noshift-screen">
            <div className="noshift-card">
                <FaBusinessTime className="noshift-icon" />
                <h2>No shift assigned</h2>
                <p>
                    You don't have a shift assigned yet, so the application is unavailable.
                    Please contact <a href="mailto:admin@dolluzcorp.com">admin@dolluzcorp.com</a> to
                    get a shift assigned to your account.
                </p>
                <button className="noshift-logout" onClick={handleLogout}>Logout</button>
            </div>
        </div>
    );
};

export default NoShift;
